import modelBaseV2 from '../model-base-v2.model';

let aiJpoModel = {
    // ── Info Tab ──────────────────────────────────────────────────────

    getStartingPoints: (filter) => {
        const qs = modelBaseV2.toQueryString(filter);
        return modelBaseV2.get('/api/jpo/ai/visitplan/starting-points?' + qs);
    },

    getDwellTimes: (filter) => {
        const qs = modelBaseV2.toQueryString(filter);
        return modelBaseV2.get('/api/jpo/ai/visitplan/dwell-times?' + qs);
    },

    // ── Shop List Tab ─────────────────────────────────────────────────

    getShops: (filter) => {
        const qs = modelBaseV2.toQueryString(filter);
        return modelBaseV2.get('/api/jpo/ai/visitplan/shops?' + qs);
    },

    // ── Summary Tab ───────────────────────────────────────────────────

    getSummary: (filter) => {
        const qs = modelBaseV2.toQueryString(filter);
        return modelBaseV2.get('/api/jpo/ai/visitplan/summary?' + qs);
    },

    getSummaryStoresPopup: (filter) => {
        const qs = modelBaseV2.toQueryString(filter);
        return modelBaseV2.get('/api/jpo/ai/visitplan/summary/stores-popup?' + qs);
    },

    getSummarySchedulesPopup: (filter) => {
        const qs = modelBaseV2.toQueryString(filter);
        return modelBaseV2.get('/api/jpo/ai/visitplan/summary/schedules-popup?' + qs);
    },

    // ── Details Tab ───────────────────────────────────────────────────

    getDetails: (filter) => {
        const qs = modelBaseV2.toQueryString(filter);
        return modelBaseV2.get('/api/jpo/ai/visitplan/details?' + qs);
    },

    // ── Map Tab ───────────────────────────────────────────────────────

    getMapData: (filter) => {
        const qs = modelBaseV2.toQueryString(filter);
        return modelBaseV2.get('/api/jpo/ai/visitplan/map?' + qs);
    },

    // ── Dropdowns ─────────────────────────────────────────────────────

    getZonesDropdown: (filter) => {
        const qs = modelBaseV2.toQueryString(filter);
        return modelBaseV2.get('/api/jpo/ai/visitplan/zones-dropdown?' + qs);
    },

    getGroupsDropdown: (filter) => {
        const qs = modelBaseV2.toQueryString(filter);
        return modelBaseV2.get('/api/jpo/ai/visitplan/groups-dropdown?' + qs);
    },

    // ── Shop Processing Report Tab ────────────────────────────────────

    getShopProcessingReport: (filter) => {
        const qs = modelBaseV2.toQueryString(filter);
        return modelBaseV2.get('/api/jpo/ai/visitplan/shop-processing-report?' + qs);
    },
};

export default aiJpoModel;
